import { makeStyles } from '@mui/styles';
const singleContentStyles = makeStyles(() => ({
    center: {
        textAlign: 'center',
        alignItems: 'center',
    },
    ['flex-start']: {
        textAlign: 'start',
        alignItems: 'flex-start',
    },
}), { name: 'Common_SingleContent' });
export default singleContentStyles;
//# sourceMappingURL=singleContent.styles.js.map